var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavouritesOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-10.6%",
    y: "-8.1%",
    width: "128.3%",
    height: "132.3%",
    filterUnits: "objectBoundingBox",
    id: "favourites-orange_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.246 1.698c-3.012-2.564-7.515-2.139-10.312.746L14.846 3.57 13.757 2.45C11.503.117 6.955-1.286 3.446 1.698-.024 4.66-.207 9.976 2.899 13.18L13.59 24.22c.343.354.796.537 1.25.537.452 0 .906-.177 1.248-.536L26.782 13.18c3.117-3.205 2.934-8.521-.536-11.483z",
    id: "favourites-orange_svg__b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#favourites-orange_svg__a)",
    xlinkHref: "#favourites-orange_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EE4900",
    fillRule: "evenodd",
    xlinkHref: "#favourites-orange_svg__b"
  }))));
}

export default SvgFavouritesOrange;